import { AuthProtocolsGetUserInfoResponse, MarqCommonEnumsClientStatusEnum } from '~/swagger/data-contracts';

// todo-@elie: DomainTypeEnum.ts 머지 필요및 @types 로 이동 필요.
export enum ChannelDisplayTypeEnum {
  Inactive = 'inactive',
  MarketplaceSocialMedia = 'marketplace_social_media',
  Marketplace = 'marketplace',
  SocialMedia = 'social_media',
  WebsiteContentDomainNames = 'website_content_domain_names',
  WebsiteContent = 'website_content',
  DomainNames = 'domain_names',
}
export const parseChannelDisplayTypeEnum = (auth: AuthProtocolsGetUserInfoResponse): ChannelDisplayTypeEnum => {
  if (auth.status !== MarqCommonEnumsClientStatusEnum.ActiveClient) {
    return ChannelDisplayTypeEnum.Inactive;
  }

  if (auth.use_ecommerce && auth.use_social_media) {
    return ChannelDisplayTypeEnum.MarketplaceSocialMedia;
  }

  if (auth.use_ecommerce) {
    return ChannelDisplayTypeEnum.Marketplace;
  }

  if (auth.use_social_media) {
    return ChannelDisplayTypeEnum.SocialMedia;
  }

  // 추후 백엔드 분리작업 이후 주석 해제
  // if (auth.use_website_content && auth.use_domain_names) {
  //   return ChannelDisplayTypeEnum.WebsiteContentDomainNames;
  // }
  //
  // if (auth.use_website_content) {
  //   return ChannelDisplayTypeEnum.WebsiteContent;
  // }
  //
  // if (auth.use_domain_names) {
  //   return ChannelDisplayTypeEnum.DomainNames;
  // }

  return ChannelDisplayTypeEnum.DomainNames;
};

// todo-@elie: constants 로 이동 필요.
export const ChannelDisplayTypeLabel: Record<ChannelDisplayTypeEnum, string> = {
  [ChannelDisplayTypeEnum.Inactive]: 'Inactive',
  [ChannelDisplayTypeEnum.MarketplaceSocialMedia]: 'Marketplace & Social media',
  [ChannelDisplayTypeEnum.Marketplace]: 'Marketplace',
  [ChannelDisplayTypeEnum.SocialMedia]: 'Social media',
  [ChannelDisplayTypeEnum.WebsiteContentDomainNames]: 'Website Content & Domain Names',
  [ChannelDisplayTypeEnum.WebsiteContent]: 'Website content',
  [ChannelDisplayTypeEnum.DomainNames]: 'Domain names',
};
